"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseResourceLink = exports.isResourceLink = exports.RESOURCE_LINK_REGEX = exports.RESOURCE_REGEX_BASE = exports.RESOURCE_LINKS = void 0;
exports.RESOURCE_LINKS = '__RESOURCE_LINKS__';
exports.RESOURCE_REGEX_BASE = '_([a-z]+)_(\\w+)';
exports.RESOURCE_LINK_REGEX = new RegExp(`^${exports.RESOURCE_REGEX_BASE}$`, 'u');
function isResourceLink(link) {
    return exports.RESOURCE_LINK_REGEX.test(link);
}
exports.isResourceLink = isResourceLink;
function parseResourceLink(link) {
    const match = exports.RESOURCE_LINK_REGEX.exec(link);
    if (!match) {
        throw new Error(`Invalid resource link: ${link}`);
    }
    return { scope: match[1], id: match[2] };
}
exports.parseResourceLink = parseResourceLink;
